import {event} from '../modules/event';
import {scriptonload} from '../modules/scriptonload';

var MovieList2 =  class {
	constructor(wrapper) {
		this._createElements(wrapper);
		this._addEvents();
	}

	_createElements(wrapper){
		this.wrapper = wrapper;
		this.frame = this.wrapper.querySelector('[data-MovieList-frame]');
		this.itemAll = this.wrapper.querySelectorAll('[data-MovieList-item]');
        this.curInd;
        this.player;
	}

	_addEvents(){
        var self = this;

		for(var i=0,j=this.itemAll.length; i<j; i++){
            var item = this.itemAll[i];
            if(item.className.indexOf('js-active') !== -1) this.curInd = i;

            event.add(item, 'click', (function(i){ return function(e){
                e.preventDefault();
                if(this.className.indexOf('js-active') !== -1) return false;

                self.itemAll[self.curInd].className = self.itemAll[self.curInd].className.replace(/\s*js-active/, '');
                this.className = this.className + ' js-active';
                self.curInd = i;

                var data = JSON.parse(this.getAttribute('data-MovieList-item'));

                self.frame.removeChild(self.frame.firstChild);

                var btn = this;

                try{self.player.del()} catch(e){};
                delete self.player;

                self.frame.innerHTML = '<div data-param=\''+ btn.getAttribute('data-MovieList-item') +'\' class="combinedPlayer"></div>'

                var init = function(){
                    self.player = uPlayer(self.frame.firstChild);
                };
                if(!window.uPlayer) scriptonload(APP.vendors.uPlayer, init);
                else init();

            }})(i));
        }
	}

};

export {MovieList2};





































